import { getDurationFrom } from './timeHelper'

export const GPS_TRACKER_LOCATION_STALE_WARNING_MINUTES = 180
export const GPS_TRACKER_RECENT_COMMUNICATION_MINUTES = 120
export const GPS_TRACKER_LOCATION_STALE_WARNING_MESSAGE = '通信はできていますが、GPS位置情報の更新に時間がかかっています。\n空が見えやすい屋外へ移動すると更新されやすくなります。'

const getElapsedMinutes = (dateTime?: string | null): number | null => {
  if (!dateTime) return null

  const minutes = getDurationFrom(dateTime).asMinutes()

  return Number.isFinite(minutes) && minutes >= 0 ? minutes : null
}

export const shouldShowGpsTrackerLocationStaleWarning = (
  status?: Pick<IGpsTrackerStatus, 'tracked_at' | 'gps_location_updated_at'> | null,
): boolean => {
  const communicationElapsedMinutes = getElapsedMinutes(status?.tracked_at)
  const gpsLocationElapsedMinutes = getElapsedMinutes(status?.gps_location_updated_at)

  if (communicationElapsedMinutes === null || gpsLocationElapsedMinutes === null) {
    return false
  }

  return communicationElapsedMinutes <= GPS_TRACKER_RECENT_COMMUNICATION_MINUTES
    && gpsLocationElapsedMinutes >= GPS_TRACKER_LOCATION_STALE_WARNING_MINUTES
}
